import { storableError } from '../../util/errors';
import { fetchSeoCityPage } from '../../util/seoDiscoveryFetch';

export const FETCH_CITY_REQUEST = 'app/SeoDiscoveryCityPage/FETCH_REQUEST';
export const FETCH_CITY_SUCCESS = 'app/SeoDiscoveryCityPage/FETCH_SUCCESS';
export const FETCH_CITY_ERROR = 'app/SeoDiscoveryCityPage/FETCH_ERROR';

const initialState = {
  payload: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CITY_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_CITY_SUCCESS:
      return { ...state, fetchInProgress: false, payload };
    case FETCH_CITY_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_CITY_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_CITY_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_CITY_ERROR, payload: storableError(e) });

export const loadCityData = citySlug => dispatch => {
  dispatch(fetchRequest());
  return fetchSeoCityPage(citySlug)
    .then(data => dispatch(fetchSuccess(data)))
    .catch(e => {
      dispatch(fetchError(e));
      throw e;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const slug = params?.citySlug;
  if (!slug) {
    return Promise.resolve();
  }
  return dispatch(loadCityData(slug));
};
